import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CHOICE } from "./abstract/choiceAbstract";

const _action = `${ACTION_PREFIX_CHOICE}_update_name`;
const _header = `Rename parameter`;

export const updateChoiceName = (root, id, name,lastPayload) => {
  const _payload = updateChoiceNameLogic(root, id, name, lastPayload);

  logger.logAction(_action, _payload, ACTION_PREFIX_CHOICE);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const updateChoiceNameLogic = (root, id, name, lastPayload) => {
  const { data: _node, index: _index } = getNodeById(root, id);

  if (!_node) {
    throw new Error("Choice to update not found");
  }

  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));
  
  if (!_nodeParent) {
    throw new Error("Parent node not found");
  }

    if (nodeUtils.getName(_node) === name) {
      return generatePayloadIndifferent();
    }

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  nodeUtils.setName(_node, name, true);

  return generatePayload(_nodeBackup, _index, _nodeParent, nodeUtils.getName(_node), lastPayload);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, nameAfter, lastPayload) => {
  if (!nodeUtils.getName(node)) {
    return generatePayloadCreate(node, index, nodeParent, nameAfter, lastPayload);
  }

  return generatePayloadUpdate(node, index, nodeParent, nameAfter)
}

const generatePayloadCreate = (node, index, nodeParent, nameAfter, previousAction) => {

  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: `${previousAction.description} Name: '${nameAfter}'.`,
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    nameBefore: nodeUtils.getName(node),
    nameAfter: nameAfter,
  }

  return _payload;
}

const generatePayloadUpdate = (node, index, nodeParent, nameAfter) => {
  const _payload = {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node, nameAfter),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    nameBefore: nodeUtils.getName(node),
    nameAfter: nameAfter,
  };

  return _payload;
};

const generatePayloadIndifferent = () => {
  const _payload = {
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp()
  }

  return _payload;
}

const generatePayloadDescription = (node, nameAfter) => {

    return `Rename choice '${nodeUtils.getName(node)}' to '${nameAfter}'.`;
}
